export default __webpack_public_path__ + "static/media/flags.4c2fa25b.png";